// pages/products/signage/SolarLedSign.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  TypeBlock
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const SolarLedSign = () => {

  const compositionGroups = [
    {
      items: [
        { src: '/images/products/signage/solar-led-config.webp' },
      ],
    },
  ];
  
  return (
    <>
      <HeroSection
        title={`태양광 LED \n내부 조명 표지판`}
        subtitle={`야간이나 악천후에도 뛰어난 시인성으로 \n사고를 예방합니다`}
        backgroundImage="/images/products/signage/seagull-sign.webp"
        breadcrumbs={[
            { label: '홈', path: '/' },
            { label: '도로 안내표지시스템', path: '/products/signage' },
            { label: '태양광 LED 내부 조명 표지판' }, // 현재 페이지는 path 없음
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`시야 확보가 어려운 환경에서도, 안전한 교통을 위해`}
        title={`태양광 LED 내부 조명 표지판`}
        description={`내부에 LED 조명, 외부에는 투과성 재귀반사 시트를 적용한 고시인성 조명식 표지판으로, 야간이나 악천후에도 뛰어난 시인성을 확보하여 운전자의 사고를 사전에 예방합니다. \n
            또한, 태양광을 활용한 전원 공급 방식을 겸할 수 있어 전기 인입이 어려운 지역이나 도심 외곽, 산간 도로 등 다양한 지형에도 설치가 가능하고 주·야간 인지도가 높으며 유지관리가 용이합니다.
        `}
        images={[
          '/images/products/signage/solar-led-sign.webp',
          '/images/products/signage/seagull-sign.webp',
        ]}
        badgeImages={[
            "/images/logo/Nara.webp",
        ]}
      />

      <SectionDivider />

      <InfoSection title="제품 구성도">
        <TypeBlock groups={compositionGroups} />
      </InfoSection>

      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/solar-led-sign"
        listPath="/products/signage"
      />


      <CTASection />
    </>
  );
};

export default SolarLedSign;
